import React from 'react';
import { func } from 'prop-types';
import Icon from 'components/icon';
import toClassName from '../../utils/to-class-name';
import { dateToString } from '../../utils/dates';
import DetailsItem from './HeaderItem';
import { edocketSummaryType } from './edocketObjectType';

export default function Header({ closeModal, edocketSummary }) {
    const date = new Date(edocketSummary.DocketDate);

    return (
        <div className="edocket-detail-header">
            <div className="btn-wrapper">
                <button
                    onClick={closeModal}
                    className="close-btn modal-closer"
                >
                    <Icon glyph="cross" />
                </button>
            </div>
            <div className="title">
                <span className="edocket-number">
                    Docket {edocketSummary.eDocketNumber}
                </span>
                {
                    edocketSummary.DraftDocketStatus.length > 0 &&
                    <span className={`status-span ${toClassName(edocketSummary.DraftDocketStatus)}`}>
                        {edocketSummary.DraftDocketStatus}
                    </span>
                }
            </div>
            <div className="details">
                <DetailsItem
                    label="Customer"
                    value={edocketSummary.ClientName}
                />
                <DetailsItem
                    label="Date"
                    value={dateToString(date)}
                />
                <DetailsItem
                    label="Job"
                    value={edocketSummary.FPHJobNumber}
                />
                <DetailsItem
                    label="Site"
                    value={edocketSummary.SiteName}
                />
                {edocketSummary.SiteForeman && (
                    <DetailsItem
                        label="Foreman"
                        value={edocketSummary.SiteForeman}
                    />
                )}
                <DetailsItem
                    label={edocketSummary.PurchaseOrderNumber ? 'Purchase Order' : ''}
                    value={edocketSummary.PurchaseOrderNumber ? edocketSummary.PurchaseOrderNumber : ' '}
                />
                <DetailsItem
                    label="Contractor"
                    value={edocketSummary.SupplierTradingName}
                />
                <DetailsItem
                    label="Operator"
                    value={edocketSummary.OperatorName}
                />
                <DetailsItem
                    label="Equipment"
                    value={edocketSummary.EquipmentUsed}
                />
                <DetailsItem
                    label="Charged as"
                    value={edocketSummary.JobType}
                />
                <DetailsItem
                    label={edocketSummary.CostCode ? 'Cost Code' : ''}
                    value={edocketSummary.CostCode ? edocketSummary.CostCode : ' '}
                />
                <DetailsItem
                    label="&nbsp;"
                    value="&nbsp;"
                />
            </div>
        </div>
    );
}

Header.propTypes = {
    closeModal: func.isRequired,
    edocketSummary: edocketSummaryType.isRequired
};
